import ApiaField from '../ApiaField';
import Field from '../constants/Field';
import ApiaForm from '../ApiaForm';
import { IApiaField } from '../types';
import { ApiaUtil } from '@apia/components';

export interface ICheckField extends IApiaField {
  setValue(value: string | boolean | number): ICheckField;
  clearValue(): ICheckField | null;
}

export default class CheckField extends ApiaField implements ICheckField {
  constructor(field: HTMLInputElement, form: ApiaForm) {
    super(field, form, [
      Field.PROPERTY_REQUIRED,
      Field.PROPERTY_DISABLED,
      Field.PROPERTY_READONLY,
      Field.PROPERTY_VISIBILITY_HIDDEN,
      Field.PROPERTY_CHECKED,
      Field.PROPERTY_SHOW_TOOLTIP_AS_HELP,
    ]);
  }

  clearValue(): ICheckField | null {
    if (this.checkFieldExistsInDocument(this.fldId)) {
      this.setValue(false);
      return this;
    }
    return null;
  }

  setValue(value: string | boolean | number): ICheckField {
    // accepts 1/0 or true/false as values
    let val;
    const isBool = ApiaUtil.instance.parsers.parseBool(
      value as unknown as string,
    );
    if (isBool === true || isBool === false) {
      val = isBool;
    } else {
      throw new Error(
        'Apia JSApi Error: The function setValue for a Checkbox field only accepts boolean or string type for value parameter.',
      );
    }
    super.setValue(val);
    return this as ICheckField;
  }
}
